import React from 'react';
import { Link } from 'react-router-dom';
import { Items } from '../../Routes';

const Logo = (props) => {
    return (
        <div className="logo">
            <Link to={Items.slice(0)[0].path} className="logo">
                <span className={props.logo}>WorldCardTeam</span>
            </Link>
        </div>
    )
}

export default Logo;